import React from 'react';
import {IStoryBlokComponent} from '~src/interfaces/storyblock';
import {IMarketData} from '../../interfaces';
import {buildAlignmentClass} from '../../../../utils/alignment';
import styles from './event-cards.module.scss';
import Button from '~components/web-ui-react/button';

interface ICardAlignmentItem {
  target_device: string;
  size: string;
}

export interface EventCardInterface extends IStoryBlokComponent {
  card_alignment_item: Array<ICardAlignmentItem>
  card_button_content: string;
  card_live_text: string;
  infomeetings: Array<IMarketData>;
  openModal: (id: string) => void;
}

const EventCard = (props: EventCardInterface) => {
  const {
    card_alignment_item,
    card_button_content,
    infomeetings,
    openModal
  } = props;
  const cardAlignmentClasses = card_alignment_item?.reduce((acc, current) => {
    return acc + buildAlignmentClass(current) + ' ';
  }, ' ') || '';

  return (
    <section>
      {infomeetings?.map(marketData => (
          <div className='ef-row' key={marketData.id}>
            <div
              className={`ef-col${cardAlignmentClasses} ${styles.infomeetingCards}`}
            >
              <a
                className={`ef-card--content ${styles.infomeetingCardsContent}`}
                onClick={() => openModal(marketData.id)}
              >
                <div className='event-big-date ef-col -s-12 -m-2 u-s-pb-0 u-s-pt-m u-s-pl-l u-m-p-l'>
                  <div className={styles.infomeetingCardsDate}>
                    <h4 className='u-mb-xs'>{marketData.eventDate.big}</h4>
                  </div>
                </div>
                <div className='ef-card--content__inner ef-col -s-12 -m-7 u-s-pt-s u-s-pb-s u-m-pb-l u-m-pt-l'>
                  <div className='ef-card--content__content'>
                    <span className='u-mb-xs'>{marketData.eventDate.small}</span>
                    <h2 className={`ef-h5 ef-card--content__title u-mb-0`}>
                      {marketData.title}
                    </h2>
                    <p className='ef-text-body'>{marketData.description}</p>
                  </div>
                </div>
                <div className='ef-col -s-12 -m-2 u-m-text-center u-s-mb-l u-s-pl-l u-m-mb-0'>
                  <Button text={card_button_content} primary small/>
                </div>
              </a>
            </div>
          </div>
        )
      )}
    </section>
  )
}

export default EventCard;
